import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, useParams } from 'react-router-dom'
import {
  setLanguage,
  setPhone,
  setUserName,
} from '../../redux/actions/language'
import {
  loadCurrentApplicantCompletion,
  loadCurrentApplicantProfile,
} from '../../config/applicantApi'
import ProfileSidebar from '../profile/profileForms/ProfileSidebar'
import { loadMyApplicationOverview } from './api'
import MyApplicationContent from './MyApplicationContent'

export default function MyApplicationPage() {
  const dispatch = useDispatch()
  const { isLogin } = useSelector((state) => state.globalReducer)
  const { language } = useParams()
  const applicantID = localStorage?.getItem('applicantID')
  const userToken = localStorage?.getItem('authToken') || ''

  const [jobAppliedTotal, setJobAppliedTotal] = useState(0)
  const [profileData, setProfileData] = useState(() => {
    try {
      const localProfileData = localStorage?.getItem('localProfileData')

      return localProfileData
        ? JSON.parse(localProfileData)
        : {
            fullName: '',
            email: '',
            mobilePhoneNumber: '',
          }
    } catch {
      return {
        fullName: '',
        email: '',
        mobilePhoneNumber: '',
      }
    }
  })
  const [profileCompletion, setProfileCompletion] = useState(() => {
    const storedValue = localStorage?.getItem('profileCompletion')
    return storedValue ? Number(storedValue) : 0
  })

  useEffect(() => {
    if (language) {
      dispatch(setLanguage(language))
    }
  }, [dispatch, language])

  useEffect(() => {
    if (!userToken) return

    const loadPageData = async () => {
      const [nextProfile, nextApplications, nextCompletion] = await Promise.all([
        loadCurrentApplicantProfile({ userToken }),
        loadMyApplicationOverview({ userToken }),
        loadCurrentApplicantCompletion({ userToken }),
      ])

      if (nextProfile) {
        setProfileData(nextProfile)
        localStorage?.setItem('localProfileData', JSON.stringify(nextProfile))
        dispatch(setUserName(nextProfile.fullName))
        dispatch(setPhone(nextProfile.mobilePhoneNumber))
      }

      if (Array.isArray(nextApplications)) {
        setJobAppliedTotal(nextApplications.length)
      }

      if (typeof nextCompletion === 'number') {
        setProfileCompletion(nextCompletion)
        localStorage?.setItem('profileCompletion', nextCompletion)
      }
    }

    loadPageData()
  }, [dispatch, userToken])

  if ((!applicantID || !userToken) && isLogin === false) {
    return <Navigate to={`/${language || 'id'}/login`} replace />
  }

  return (
    <div>
      <div className='relative mx-auto mt-6 flex w-full max-w-[1200px] flex-col gap-6 pb-4 px-4 md:mt-12 md:px-6 lg:flex-row lg:items-start lg:px-4'>
        <ProfileSidebar
          profileData={profileData}
          jobAppliedTodal={jobAppliedTotal}
          profileCompletion={profileCompletion}
        />
        <div className='w-full min-w-0 flex-1'>
          <MyApplicationContent />
        </div>
      </div>
    </div>
  )
}
